// -- React Libraries
import React from 'react';

// -- Components
import MediaQuery from 'react-responsive';
import GridHeader from "../GridHeader/index";
import GridContent from "../GridContent/index";

// -- Styles
import StyleWrapper from "./Wrapper";

export default class GridAppName extends React.Component {
    constructor (props) {
        super(props);

        this.appName = props.data.name;

        this.isFormatOk = props.data.isFormatOk;
        this.isBrandOk = props.data.isBrandOk;
        this.isLengthOk = props.data.isLengthOk;

        this.brandLength = props.data.brandLength;
        this.nameLength = props.data.nameLength;
    }

    render() {
        return (
            <StyleWrapper className="grid-score-summaries">
                <div className="summary-title">应用名称: {this.appName}</div>
            
                <div className="grid-container">
                    {/* First Row */}
                    <GridHeader ok={this.isFormatOk} title="格式"></GridHeader>
                    <GridHeader ok={this.isBrandOk} title="品牌名称">{this.brandLength}个字元</GridHeader>
                    <GridHeader ok={this.isLengthOk} title="长度 ">{this.nameLength}个字元</GridHeader>

                    {/* Second Row */}
                    <GridContent title={this.isFormatOk && "很好！"}>
                        {
                            this.isFormatOk && (
                                <div>
                                    你使用的应用名称格式为<span>”品牌名称 - 关键词"</span>，你的排名会因而排得更高。
                                </div>
                            ) || (
                                <div>
                                    你应该使用<span>”品牌名称 - 关键词"</span>为应用名称格式，你的排名会因而排得更高。
                                </div>
                            )
                        }
                    </GridContent>

                    <GridContent title={this.isBrandOk && "很好！"}>
                        {
                            this.isBrandOk && (
                                <div>
                                    你的品牌名称的长度适合任何装置。
                                </div>
                            ) || (
                                <div>
                                    你的品牌名称太长了，试试减少到24个字元以内。
                                </div>
                            )
                        }
                    </GridContent>

                    <GridContent title={this.isLengthOk && "很好！"}>
                        {
                             this.isLengthOk && (
                                <div>
                                    你的品牌名称的长度拥有最大优势。
                                </div>
                            ) || (
                                <div>
                                    最少使用20个字元来覆盖更多相关关键词。
                                </div>
                            )
                        }
                    </GridContent>
                    
                    {/* Third Row */}
                    <GridContent title={"小窍门:"}>
                        - 把<span>关键词</span>包含在你的应用名称内
                    </GridContent>

                    <GridContent title={"小窍门:"}>
                        - 要令<span>每个装置都能获得最佳展示</span>
                    </GridContent>

                    <GridContent title={"小窍门:"}>
                        - 每个应用名称的最佳长度为<span>30个字元</span>
                    </GridContent>
                </div>
            </StyleWrapper>
        );
    }
};


// WEBPACK FOOTER //
// ./src/containers/AsoAnalytic/ScoreSummary/GridAppName/index.js